import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersona = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21 5.70001V13.39C20.87 13.83 20.64 14.23 20.31 14.56L14.57 20.3C14.24 20.63 13.84 20.87 13.4 20.99H5.70001C4.22001 20.99 3 19.77 3 18.29V5.69C3 4.2 4.22001 2.98999 5.70001 2.98999H18.3C19.78 2.98999 21 4.2 21 5.69V5.70001Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.25977 8.57996C7.25977 9.52996 8.02976 10.29 8.96976 10.29C9.90976 10.29 10.6797 9.52996 10.6797 8.57996",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8301 8.57996C12.8301 9.52996 13.5901 10.29 14.5401 10.29C15.4901 10.29 16.2501 9.52996 16.2501 8.57996",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9999 13.39C20.8699 13.83 20.6399 14.23 20.3099 14.56L14.5699 20.3C14.2399 20.63 13.8399 20.87 13.3999 20.99C12.6099 20.05 12.1299 18.84 12.1299 17.52C12.1299 17.48 12.1299 17.46 12.1299 17.42C12.1299 16.29 12.5099 15.23 13.1299 14.38C14.1099 13.01 15.7099 12.12 17.5199 12.12C18.8399 12.12 20.0599 12.6 20.9899 13.39H20.9999Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1301 14.38C12.5101 15.24 12.1401 16.29 12.1301 17.42C11.6601 17.47 11.1901 17.44 10.7401 17.31C9.34011 16.93 8.22013 15.78 7.76013 14.28C7.71013 14.15 7.81014 14 7.95014 14C9.65014 14.41 11.4001 14.53 13.1201 14.38H13.1301Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPersona;
